import React from "react";

export default class CoworkersInUnitDropDown extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { onChange, coworkers, coworkerId } = this.props;
    if (!coworkers) return <div />;

    return (
      <select
        name="manager-coworkers"
        aria-label="manager-coworkers"
        defaultValue={coworkerId && coworkerId.toLowerCase()}
        onChange={onChange}
        ref="dropDown"
      >
        {coworkers.map((coworker) => {
          {
            return (
              coworker.personalID && (
                <option
                  value={coworker.personalID.toLowerCase()}
                  key={coworker.personalID.toLowerCase()}
                >
                  {coworker.firstName + " " + coworker.lastName}
                </option>
              )
            );
          }
        })}
      </select>
    );
  }
}
